<template>
  <b-row>
    <b-col md="4">
      <b-form-group
          :invalid-feedback="
                invalidFeedbackGroupTitle
                  ? $t(`validation.${invalidFeedbackGroupTitle}`, {
                      field: $t('permissions.permissionGroupTitle'),
                    })
                  : ''
              "
          :label="$t('permissions.permissionGroupTitle')"
          :state="$v.groupToEdit.title.$dirty ? !$v.groupToEdit.title.$invalid : null"
          label-for="permission-group-title"
      >
        <b-form-input
            id="permission-group-title"
            v-model="groupToEdit.title"
            :state="$v.groupToEdit.title.$dirty ? !$v.groupToEdit.title.$invalid : null"/>
      </b-form-group>
    </b-col>
    <b-col class="mb-2" cols="12">
      <vue-good-table
          v-if="formattedPermissions"
          :columns="columns"
          :rows="formattedPermissions"
          class="permission-table permission-table-2"
          styleClass="vgt-table "
      >
        <template slot="table-column" slot-scope="props">
         <span v-if="props.column.label === 'title'" class="text-nowrap">
              {{ $t("permissions.permissions") }}
            </span>
          <span v-else class="text-nowrap">
            </span>
        </template>

        <!-- Slot: Table Row -->
        <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'title'" class="text-nowrap d-flex">
        <!-- Column: Name -->
        <b-form-checkbox
            :id="`checkbox-${props.row.key}`"
            :value="props.row"
            @change="permissionChecked($event,props.row)"
        >
        </b-form-checkbox>
          <!--        <span v-if="props.column.field === 'permissions'" class="text-nowrap">-->
  <span>
          {{ props.row.title }}</span>
          <!--        </span>-->
        </span>
          <span v-if="props.column.field === 'child'" class="text-nowrap">
<!--          {{props.row.children}}-->
            <nested-table v-if="props.row.children.length" ref="nestedTable" :childColumns="childColumns"
                          :children="props.row.children"></nested-table>
            </span>
        </template>
        <div slot="emptystate">

        </div>
      </vue-good-table>
    </b-col>
    <b-col class="d-flex justify-content-end mb-2" cols="12">
      <b-button
          size="sm"
          variant="primary"
          @click="EditGroup"
      >{{ $t("permissions.createGroup") }}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BCol,
  BRow,
  BButton,
  BFormCheckbox
} from 'bootstrap-vue'
import {VSelectTree} from 'vue-tree-halower'
import {VueGoodTable} from 'vue-good-table'
import NestedTable from "@/components/NestedTable";
import {required} from "vuelidate/lib/validators";

export default {
  components: {
    BFormGroup,
    BFormInput,
    BCol,
    BRow,
    BButton,
    BFormCheckbox,
    VSelectTree,
    VueGoodTable,
    NestedTable
  },
  data: () => ({
    selectedPermissions: [],
    checkedItemChildren: [],
    flattenFormattedPermissions: [],
    formattedPermissions: [],
    columns: [
      {
        label: "title",
        field: "title",
        sortable: false
      }, {
        label: "child",
        field: "child",
        sortable: false
      }
    ],
    childColumns: [
      {
        label: "title",
        field: "title",
        sortable: false
      },
      {
        label: "child",
        field: "child",
        sortable: false
      }
    ]
  }),
  validations() {
    return {
      groupToEdit: {
        title: {
          required,
        },
      }
    };
  },
  created() {
    this.$store.commit('SET_IS_LOADING', true)
    this.$store.dispatch('permissions/getAPermissionGroup', this.$route.params.groupId).then(res => {
      this.groupToEdit = res;
      this.$store.dispatch('permissions/getPermissions').then((res) => {
        this.createFormattedPermission(res);
        // return roots;
        this.$store.dispatch('permissions/getPermissionGroups').then(() => {
          if (this.groupToEdit.permissions.length){
          this.groupToEdit.permissions.forEach(userPermission => {
            this.selectedUserPermissions.push(this.flattenFormattedPermissions.find(p => {
              if (p._id === userPermission) {
                document.getElementById(`checkbox-${p.key}`).checked = true;
                // this.selectedUserPermissions.push(p)
                this.checkParentElement(p)
              }
              return p._id === userPermission
            }))
          })}
          else{
            this.$store.commit('SET_IS_LOADING', false)
          }
        })
      })


    })

  },
  computed: {
    permissions: {
      get() {
        return this.$store.getters['permissions/permissions']
      },
      set(permissions) {
        this.$store.commit('permissions/SET_PERMISSIONS', permissions)
      }
    },
    permissionGroups: {
      get() {
        return this.$store.getters['permissions/permissionGroups']
      },
      set(permissionGroups) {
        this.$store.commit('permissions/SET_PERMISSION_GROUPS', permissionGroups)
      }
    },
    permissionGroupTitle: {
      get() {
        return this.$store.getters['permissions/permissionGroupTitle']
      },
      set(permissionGroupTitle) {
        return this.$store.commit('permissions/SET_PERMISSION_GROUP_TITLE', permissionGroupTitle)
      }
    },
    groupToEdit: {
      get() {
        return this.$store.getters['permissions/groupToEdit']
      },
      set(groupToEdit) {
        this.$store.commit('permissions/SET_GROUP_TO_EDIT', groupToEdit)
      }
    },
    invalidFeedbackGroupTitle: {
      set(error) {
      },
      get() {
        var error = "";
        if (!this.$v.groupToEdit.title.$dirty) return error;
        if (!this.$v.groupToEdit.title.required) error = "required";
        return error;
      },
    },
    selectedUserPermissions: {
      get() {
        return this.$store.getters['permissions/selectedUserPermissions']
      },
      set(permissions) {
        this.$store.commit('permissions/SET_SELECTED_USER_PERMISSIONS', permissions)
      }
    },
  },
  methods: {
    EditGroup() {
      this.$v.$touch();
      let permissionsPayload = [];
      if (this.selectedUserPermissions.length) {
        this.selectedUserPermissions.forEach(s => {
          s && s.children.length === 0 ? permissionsPayload.push(s._id) : ''
        })
      }
      if (!this.$v.$invalid) {
        let payload = {
          permissions: permissionsPayload,
          title: this.groupToEdit.title
        }
        this.$store.dispatch('permissions/editPermissionGroup', {
          group: payload,
          id: this.$route.params.groupId
        }).then((res) => {
          this.$root.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
            // title: this.$t('toastification.success'),
            variant: 'success',
            solid: true,
          });
          this.$store.commit('permissions/RESET_PERMISSION_GROUP');
          // this.$emit('groupCreated');
          this.$v.$reset();
          this.$router.push({name: 'managePermissionGroups'});
        })
      }
    },
    permissionChecked(event, selected) {
      this.checkedItemChildren = [];
      this.getAllChildren(selected);
      if (event) {
        !this.selectedUserPermissions.find(s => {
          return s._id === selected._id
        }) ? this.selectedUserPermissions.push(selected) : '';
        this.checkedItemChildren.forEach((c) => {
          !this.selectedUserPermissions.find(s => {
            return s._id === c._id
          }) ? this.selectedUserPermissions.push(c) : '';
          document.getElementById(`checkbox-${c.key}`).checked = true;
        })
      } else {
        this.selectedUserPermissions.find(s => {
          return s._id === selected._id
        }) ? this.selectedUserPermissions = this.selectedUserPermissions.filter((s) => {
          return s._id !== selected._id
        }) : '';
        this.checkedItemChildren.forEach((c) => {
          this.selectedUserPermissions.find(s => {
            return s._id === c._id
          }) ? this.selectedUserPermissions = this.selectedUserPermissions.filter((s) => {
            return s._id !== c._id
          }) : '';
          document.getElementById(`checkbox-${c.key}`).checked = false;
        })
      }
    },
    getAllChildren(node) {
      for (var i = 0; i < node.children.length; i++) {
        var child = node.children[i];
        this.getAllChildren(child);
        this.checkedItemChildren.push(child);
        // doSomethingToNode(child);
      }
    },
    flatten(array) {
      var result = [];
      let parent = this;
      array.forEach(function (a) {
        result.push(a);
        if (Array.isArray(a.children)) {
          result = result.concat(parent.flatten(a.children));
        }
      });
      return result;
    },
    checkParentElement(element) {
      let parentId = this.flattenFormattedPermissions.find(p => {
        return p._id === element._id
      }).parentId;
      if (parentId) {
        document.getElementById(`checkbox-${this.flattenFormattedPermissions.find(p => {
          return p._id === parentId
        }).key}`).checked = true;
        this.selectedUserPermissions.push(this.flattenFormattedPermissions.find(p => {
          return p._id === parentId
        }))
      }
      if (this.flattenFormattedPermissions.find(p => {
        return p._id === parentId
      }) && this.flattenFormattedPermissions.find(p => {
        return p._id === parentId
      }).parentId !== null) {
        this.checkParentElement(this.flattenFormattedPermissions.find(p => {
          return p._id === parentId
        }))
      }
      this.$store.commit('SET_IS_LOADING', false)
    },
    createFormattedPermission(res) {
      let list = _.cloneDeep(res);
      var map = {}, node, roots = [], i;
      for (i = 0; i < list.length; i += 1) {
        map[list[i]._id] = i; // initialize the map
        list[i].children = []; // initialize the children
      }
      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parentId !== null) {
          // if you have dangling branches check that map[node.parentId] exists

          // list[map[node.parentId]].children = [];
          // list[map[node.parentId]].id = list[map[node.parentId]]._id;
          list[map[node.parentId]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      this.formattedPermissions = roots;
      this.flattenFormattedPermissions = this.flatten(this.formattedPermissions);
    }
  }
}
</script>